import React from "react";
import Components from "../../components";

const Register = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Kayıt Ol"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Register
        id="register"
        label="Register"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Register;
